<template> 
    <div style="width:1000px;padding-left:140px;margin-left: -185px;padding-top:40px;margin-top:-40px;overflow:hidden;height:320px;">
        <div class="slide-wrap"  @mouseover="pasue" @mouseout="play">        
            <ul class="slide-bar" :style="ulWidth" :class="{'tran': noLast}">            
                <li v-for="(item, i) in list " :style="{'width': i == current ? '196px' : '168px' }" :class="i > current ? 'cCardNot' : ''" style="margin-right:15px;" :key="item+'-'+i"  @click="changePage(i%10)">
                <img :src="item" class="cCPic" :class="computeImgClass(i)"> 
                </li>        
            </ul>        
            <!-- <div class="arrow">            
                <img :src="arrow_left" class="arrow_left" @click="prev">            
                <img :src="arrow_right" class="arrow_right" @click="next">        
            </div>         -->
               
        </div> 
        <div class="pagnator">            
            <span v-for="(index, idx) in 10" :key="index+'-'+idx" :class="{'active': idx == current}" class="carouselBtns" @click="changePage(idx)"></span>        
        </div> 
    </div>  
</template>
<script>
// import picUrl1 from '../../../static/images/gameNewPic/1.jpg'
// import picUrl2 from '../../../static/images/gameNewPic/2.jpg'
import picUrl3 from '../../../static/images/gameNewPic/3.jpg'
import picUrl4 from '../../../static/images/gameNewPic/4.jpg'
import picUrl5 from '../../../static/images/gameNewPic/5.jpg'
import picUrl6 from '../../../static/images/gameNewPic/6.jpg'
import picUrl7 from '../../../static/images/gameNewPic/7.jpg'
// import picUrl8 from '../../../static/images/gameNewPic/8.jpg'
// import picUrl9 from '../../../static/images/gameNewPic/9.jpg'
// import picUrl10 from '../../../static/images/gameNewPic/10.jpg'
// import picUrl11 from '../../../static/images/gameNewPic/11.jpg'
import picUrl12 from '../../../static/images/gameNewPic/12.jpg'
import picUrl13 from '../../../static/images/gameNewPic/13.jpg'
import picUrl14 from '../../../static/images/gameNewPic/14.jpg'
import picUrl15 from '../../../static/images/gameNewPic/15.jpg'
import picUrl16 from '../../../static/images/gameNewPic/16.jpg'

export default {    
    name: 'SlideChild',    
    data() {        
        return {            
          list: [ //数组前后各增加一张图片    
                // picUrl11,             
                // picUrl1,   
                // picUrl2,   
                picUrl3,   
                picUrl12,
                picUrl4,   
                picUrl5,   
                picUrl6,   
                picUrl7,   
                // picUrl8,   
                // picUrl9,   
                // picUrl10, 
                picUrl13,
                picUrl14,
                picUrl15,
                picUrl16,
                // picUrl11,      
                // picUrl1, 
                // picUrl2,   
                picUrl3,  
                picUrl12, 
                picUrl4,
                picUrl5,   
                picUrl6, 
                ],            
          arrow_left: 'static/image/arrow_left.png',            
          arrow_right: 'static/image/arrow_right.png',            
          bar: {                
              width: '0',                
              transform: 'translateX(0)',            
          },            
          current: 0,            
          noLast: true        
        }    
     },    
     computed: {            
        ulWidth(){                                
            this.bar = {                    
                transform: 'translateX(-'+ ((this.current) * 183) +'px)',                
             }                
             return this.bar;            
        },            
        liWidth(){                
            return 20;            
         }           
     },    
     methods: { 
        computeImgClass(i) {
            let tempClass;
            if (i == this.current ) {
                tempClass = 'bigLight cCPicOn'
            } else if (i ==  this.current -1 ) {
                tempClass = 'cCpicHide'
            } else if (i <  this.current -1 ) {
                tempClass = 'hideImmi'
            } else {
                tempClass = 'cCPicNot'
            }
            return tempClass;
        },    
        prev(){            
            this.current --;            
            if(this.current == -1) {                 
                setTimeout(() => {                    
                    //取消过渡效果,使用css来进行操作transition,如果直接用js来操作transition,达不到我们要的效果                    
                    this.noLast = false;                     
                    //切换到1234的4去，由于ul的translatex索引是this.current+1,所以1234的4为this.list.length - 3 +1 = this.list.length -2                    
                    //具体多少，得看你的布局是怎样的，有没有合并在数组里面去                      
                    this.current = this.list.length - 3;                  
                }, 500); //定时器的时间等于过渡时间            
             }            
            this.noLast = true;         
         },        
         next(){            
            this.current ++;             
            if (this.current == 10) {  
                setTimeout(() => {                    
                    this.noLast = false;
                    this.current = 0;                
                 }, 50);            
            }           
            this.noLast = true;        
         },
         changePage(i) {
            this.current = i;                
            this.noLast = true;
            this.$emit('change',i)  

         },     
         pasue(){            
            // console.log('暂停');            
            clearInterval(this.timer)        
         },        
         play(){            
            // console.log('播放');            
            // this.autoSwitch();        
          },        
          autoSwitch(){ //自动播放            
            this.timer = setInterval(() =>{                
                this.next();            
            },1000)        
          }    
    },    
    created(){ 
        // this.autoSwitch();    
     }}
</script>
<style scoped>
.slide-box {    
    width: 300px;    
    margin: auto;
}
.slide-wrap {  
    height:260px;  
}
.slide-bar {    
    display: -webkit-box;
}
.tran {    
    transition: all 0.5s;
}

.slide-bar img {     
    height: 248px;
}
.arrow img {    
    position: absolute;    
    top: 46%;    
    transform: translateY(-50%);    
    padding: 6px 0;    
    cursor: pointer;
}
.arrow .arrow_left {    
    left: 0;
}
.arrow .arrow_right {    
    right: 0;
}
.pagnator {    
    position: absolute;    
    left: 0; 
    margin-left: -45px;
    margin-top:80px;   
}
.pagnator span {    
    display: inline-block;       
    width:78px;
    height:4px;
    background:#fff;
    opacity: 0.48;
}
.pagnator span:hover,.pagnator span.active {    
    background: #fff !important;
    opacity: 1;
}
/* .extra {    
    display: none !important;
} */
.cCardNot{
    background:#000;
    height:248px;
    border-radius: 16px;
}
.cCPic{
    width:168px;
    height:248px;            
    position: relative;
    border-radius: 16px;
}
.cCPicOn {
    opacity: 1;
    top:-0px;
    left: 0px;
    transform: scale(1.17);  /*开始为原始大小*/
    box-shadow: 0px 0px 15px #FFFA68;
    z-index: 10000;
} 
.bigLight{
            position:relative;
            animation:cardsmove 1.35s;
            -webkit-animation:cardsmove 1.35s; /*Safari and Chrome*/
            animation-timing-function: linear; /*动画的速度曲线*/
            /* Safari 和 Chrome */
            -webkit-animation:cardsmove 1.35s;
            -webkit-animation-timing-function: linear; /*动画的速度曲线*/
        }
        @keyframes cardsmove
            {
                0%{
                transform: scale(1.1);
                box-shadow: 0px 0px 15px #FFFA68;
                opacity: 0.8;
                }
                25%{
                    transform: scale(1.2); 
                }
                50%{
                    transform: scale(1.17);
                }
                100%{
                    transform: scale(1.17);
                    opacity: 1;
                    box-shadow: 0px 0px 15px #FFFA68;

                }

            }
.cCPicNot{
    opacity: 0.6;
}
.cCpicHide{
    opacity: 0;
    animation:mymove 0.8s;
    -webkit-animation:mymove 0.8s; /*Safari and Chrome*/
    animation-timing-function: linear; /*动画的速度曲线*/
    -webkit-animation:mymove 0.8s;
    -webkit-animation-timing-function: linear; /*动画的速度曲线*/
}
@keyframes mymove
    {
        0%{
            opacity: 1;
            transform: scale(1.17);
        }
        100%{
           opacity: 0;
           transform: scale(1);
        }

    }
.hideImmi{
    display:none;
}
</style>


// WEBPACK FOOTER //
// src/components/parts/otherCarousel.vue